module.exports = __webpack_public_path__ + "media/images/home/icon-4-8bb92b5138c1f1d1aabcb6922268f484.png";